const button = "_35sbts4zrg";
const stateBox = "_35ss4vexld";
const stateBoxContent = "_35ss1t3956j";

export { button, stateBox, stateBoxContent };
import "./atom.cross.style.linaria.module.css";
//# sourceMappingURL=atom.cross.style.js.map
